import './mapModal.scss'
import {CloseModalIcon} from "../../../assets/images";
import {Modal} from "antd";
import { Map, Placemark, YMaps} from "@pbe/react-yandex-maps";
import {PROJECT_LINK} from "../../../constants/constants";
import { getPropsFromState } from "../../../redux/mapStateToProps";
import { connect } from "react-redux";
import ReactDOMServer from "react-dom/server";
import { useState } from "react";

function MapModal(props) {
    const {closeModal, visible, contact } = props
    // console.log(contact?.location?.latitude, contact?.location?.longitude);
    const [ymap, setYmap] = useState(null)

    const mapData = {
        center: [40.183609, 44.515196],
        zoom: 15,
    }
    function createChipsLayout (id, calculateSize) {
        // Создадим макет метки.
        const address = id === 'building'? contact?.address: contact?.officeAddress
        const html = ReactDOMServer.renderToString(
            <Balloon id={id} address={address} />);
        var Chips = ymap?.templateLayoutFactory?.createClass(html,
            {
                build: function() {
                    Chips.superclass.build.call(this);
                    const el = document.getElementById(id)
                    this.getData().geoObject.events.add(['mouseenter'], function(e) {
                        el.classList.add('selected')
                    })
                    this.getData().geoObject.events.add(['mouseleave'], function(e) {
                        el.classList.remove('selected')
                    })
                    var map = this.getData().geoObject.getMap();
                    if (!this.inited) {
                        this.inited = true;
                        // Получим текущий уровень зума.
                        var zoom = map.getZoom();
                        // Подпишемся на событие изменения области просмотра карты.
                        map.events.add('boundschange', function() {
                            // Запустим перестраивание макета при изменении уровня зума.
                            var currentZoom = map.getZoom();
                            if (currentZoom !== zoom) {
                                zoom = currentZoom;
                                this.rebuild();
                            }
                        }, this);
                    }
                    let options = this.getData().options;
                    // Получим размер метки в зависимости от уровня зума.
                    let size = calculateSize(map.getZoom());
                    // console.log('size', size, 'zoom', map.getZoom(), 'cordi', 2 * size, size);
                    let element = this.getParentElement().getElementsByClassName('map-marker')[0];
                    // По умолчанию при задании своего HTML макета фигура активной области не задается,
                    // и её нужно задать самостоятельно.
                    // Создадим фигуру активной области "Круг".
                    const width = 32;
                    const height = 32;


                    // let circleShape = { type: 'Circle', coordinates: [0, 0], radius: size / 2 };
                    let rectangleShape = { type: 'Rectangle', coordinates: [[0, 0], [width, height]] };
                    // Зададим высоту и ширину метки.
                    // element.style.width =  2 * size + 'px';
                    // element.style.height = size + 'px';
                    element.style.width = width + 'px';
                    element.style.height = height + 'px';
                    // Зададим смещение.
                    // element.style.marginLeft = element.style.marginTop = -size / 2 + 'px';

                    // Зададим фигуру активной области.
                    // options.set('shape', circleShape);
                    options.set('shape', rectangleShape);
                }
            }
        );
        return Chips;
    };

    const onPlaceMarkClick = (key) => {
      console.log('click', key)
    }

    return <Modal
        visible={visible}
        wrapClassName={'custom-modal'}
        >
        <div className={'map-wrapper'}>
            <div className={'map-close'} onClick={closeModal}>
                <CloseModalIcon/>
            </div>
            <YMaps query={{
                apikey: 'c5f70ecb-be1a-4260-9292-9ecafceda596',
                lang: 'en'
            }}>
                <Map defaultState={mapData}
                     cursors={"inherit"}
                     onLoad={(ympasInstance) => {
                         setYmap(ympasInstance)
                         // console.log('onload')
                     }}
                     className={'yandexMap'}
                     modules={["Placemark", "geocode", "geoObject.addon.balloon", "geoObject.addon.hint", "templateLayoutFactory", "layout.ImageWithContent"]}

                >
                    {contact?.location && <Placemark
                        geometry={[contact?.location?.latitude, contact?.location?.longitude]}
                        options={{
                            iconLayout: createChipsLayout('building', function(zoom) {
                                // Минимальный размер метки будет 8px, а максимальный мы ограничивать не будем.
                                // Размер метки будет расти с линейной зависимостью от уровня зума.
                                // return 4 * zoom + 8;
                                return 50;
                            })
                        }}
                        onClick={() => onPlaceMarkClick('building')}
                        key={'building'}
                    />}
                    {contact?.office_location && <Placemark
                        geometry={[contact?.office_location?.latitude, contact?.office_location?.longitude]}
                        options={{
                            iconLayout: createChipsLayout('office', function(zoom) {
                                // Минимальный размер метки будет 8px, а максимальный мы ограничивать не будем.
                                // Размер метки будет расти с линейной зависимостью от уровня зума.
                                // return 4 * zoom + 8;
                                return 50;
                            })
                        }}
                        onClick={() => onPlaceMarkClick('office')}
                        key={'office'}
                    />}
                    {/*{contact?.location && <Placemark
                        geometry={[contact?.location?.latitude, contact?.location?.longitude]}
                        classname={'customIcon'}
                        options={{
                            iconLayout: 'default#image',
                            iconImageHref: PROJECT_LINK.iconUrl,
                            // iconImageSize: [40, 55],
                            // iconImageOffset: [-15, -60],
                        }}
                    />}
                    {contact?.office_location && <Placemark
                        geometry={[contact?.office_location?.latitude, contact?.office_location?.longitude]}
                        classname={'customIcon'}
                        options={{
                            iconLayout: 'default#image',
                            iconImageHref:PROJECT_LINK.iconUrl,
                            // iconImageSize: [40, 55],
                            // iconImageOffset: [-15, -60],
                        }}
                    />}*/}
                </Map>
            </YMaps>
        </div>
    </Modal>

}

function Balloon ({ id, address}) {
    return (
        <div id={id} className={`map-marker`}>
            <div className={'content'}>
                {address}
            </div>
            <div className={'placemark'}>
              {/*<img src={PROJECT_LINK.iconUrl}/>*/}
            </div>
        </div>
    );

}

const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
    'contact',
]);

export default connect(mapStateToProps, )(MapModal);
